(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('NewsInternalController', NewsInternalController);

    /** @ngInject */
    function NewsInternalController($state, $location, $timeout, $q, $stateParams, NewsService, HelperService) {
        const vm = this;
        const amountOfItemsPerTemplate = 4;

        let informativeRegisters = [];
        let amountOfTemplates;

        vm.isTemplateUsed = index => {
            return index < amountOfTemplates;
        }

        init();

        function getInformative() {
            const newsId = $stateParams.newsId;

            if (!newsId)
                $state.go('app-master.default.news');

            vm.isLoading = true;

            return NewsService
                .get(newsId)
                .then(success => {
                    vm.informativeData = success;

                    let informativeQueryString = `?NewsId=${vm.informativeData.Id}&NewsTitle=${vm.informativeData.Title}`;

                    if (vm.informativeData.Informative_File.length) {
                        vm.informativeFiles = vm.informativeData.Informative_File.reduce((acc, cur) => {
                            acc.push({
                                RegisterArea: 1,
                                Id: cur.File.Id,
                                Title: cur.File.Title,
                                Description: cur.File.Description,
                                Extension: cur.File.Extension.trim(),
                                Size: cur.File.Size,
                                Thumbnail: cur.File.Thumbnail,
                                RegistrationDate: cur.File.RegistrationDate,
                                Order: cur.Order
                            });

                            return acc;
                        }, []);
                    }

                    if (vm.informativeData.Informative_FileFolder.length) {
                        let fileFolders = vm.informativeData.Informative_FileFolder.reduce((acc, cur) => {
                            acc.push({
                                RegisterArea: 2,
                                Id: cur.FileFolder.Id,
                                Title: cur.FileFolder.Title,
                                Description: cur.FileFolder.Description,
                                RegistrationDate: cur.FileFolder.RegistrationDate,
                                Order: cur.Order,
                                Url: '/files'
                            });

                            return acc;
                        }, []);

                        informativeRegisters = informativeRegisters.concat(fileFolders);
                    }

                    if (vm.informativeData.Informative_Communicate.length) {
                        let communicates = vm.informativeData.Informative_Communicate.reduce((acc, cur) => {
                            acc.push({
                                RegisterArea: 3,
                                Id: cur.Communicate.Id,
                                Title: cur.Communicate.Title,
                                RegistrationDate: cur.Communicate.RegistrationDate,
                                Order: cur.Order,
                                Url: `/communicates/${cur.Communicate.Url}${informativeQueryString}`
                            });

                            return acc;
                        }, []);

                        informativeRegisters = informativeRegisters.concat(communicates);
                    }

                    if (vm.informativeData.Informative_Event.length) {
                        let events = vm.informativeData.Informative_Event.reduce((acc, cur) => {
                            acc.push({
                                RegisterArea: 4,
                                Id: cur.Event.Id,
                                Title: cur.Event.Title,
                                Description: cur.Event.Resume,
                                Image: cur.Event.Image,
                                RegistrationDate: cur.Event.RegistrationDate,
                                StartDate: cur.Event.StartDate,
                                Order: cur.Order,
                                Url: `/events/${cur.Event.Url}${informativeQueryString}`
                            });

                            return acc;
                        }, []);

                        informativeRegisters = informativeRegisters.concat(events);
                    }

                    if (vm.informativeData.Informative_News.length) {
                        let news = vm.informativeData.Informative_News.reduce((acc, cur) => {
                            acc.push({
                                RegisterArea: 5,
                                Id: cur.News.Id,
                                Title: cur.News.Title,
                                Description: cur.News.Description,
                                Image: cur.News.Image,
                                RegistrationDate: cur.News.RegistrationDate,
                                Category: cur.News.NewsCategory,
                                Order: cur.Order,
                                Url: `/media/${cur.News.NewsCategory.Url}/${cur.News.Url}${informativeQueryString}`
                            });

                            return acc;
                        }, []);

                        informativeRegisters = informativeRegisters.concat(news);
                    }

                    if (vm.informativeData.Informative_Video.length) {
                        let videos = vm.informativeData.Informative_Video.reduce((acc, cur) => {
                            acc.push({
                                RegisterArea: 6,
                                Id: cur.Video.Id,
                                Title: cur.Video.Title,
                                Description: cur.Video.Description,
                                RegistrationDate: cur.Video.RegistrationDate,
                                Category: cur.Video.VideoCategory,
                                Order: cur.Order,
                                Url: `/university/${cur.Video.VideoCategory.Url}/${cur.Video.Url}${informativeQueryString}`
                            });

                            return acc;
                        }, []);

                        informativeRegisters = informativeRegisters.concat(videos);
                    }

                    vm.informativeFiles.sort(orderRegisters);
                    informativeRegisters.sort(orderRegisters);

                    vm.isLoading = false;

                    HelperService.stopLoading('.news-loader');
                }, error => {
                    HelperService.errorCallback(error);
                    $state.go('app-master.default.news');
                })
        }

        function setTemplates() {
            vm.templates = [{
                TemplateId: 1,
                AmountOfRegisters: 4
            }, {
                TemplateId: 2,
                AmountOfRegisters: 4
            }, {
                TemplateId: 3,
                AmountOfRegisters: 4
            }]

            if (informativeRegisters.length >= amountOfItemsPerTemplate) {
                let quocient = parseInt(informativeRegisters.length / amountOfItemsPerTemplate);
                let remainder = informativeRegisters.length % amountOfItemsPerTemplate;
                amountOfTemplates = remainder > 0 ? quocient + 1 : quocient;
            } else
                amountOfTemplates = 1;

            let currentTemplate = 0;

            for (let index = 0; index < amountOfTemplates; index++) {
                if (currentTemplate >= vm.templates.length)
                    currentTemplate = 0;

                vm.registersTemplates.push({
                    TemplateId: vm.templates[currentTemplate].TemplateId,
                    Items: informativeRegisters.splice(0, amountOfItemsPerTemplate)
                });
                
                currentTemplate++;
            }
        }

        function orderRegisters(a, b) {
            return a.Order - b.Order;
        }

        function initVars() {
            vm.isLoading = false;
            vm.informativeData = {};
            vm.registersTemplates = [];
            vm.informativeFiles = [];
            vm.templates = [];
        }

        function init() {
            initVars();

            HelperService.startLoading('.news-loader');

            $q.all([getInformative()])
                .then(() => {
                    setTemplates();

                    $timeout(() => {
                        const queryString = $location.search();

                        if (queryString.scrollToDownloads) {
                            $('html, body').animate({
                                scrollTop: ($('.news-files').offset().top - ($('.header').outerHeight()))
                            }, 600);
                        }
                    }, 500);
                });
        }
    }
}());